import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    appSettings: (config: AxiosRequestConfig) => api.get(`/settings`, config),
    translate: (config: AxiosRequestConfig) => api.get(`/translate`, config),
};

export default requests;
